import { Adapter } from './adapter';
import { Voucher } from '../models/_index';

/**
 * Adapts raw voucher object to a Voucher Model
 * NOTE: The item fields are the default json property names, hence the tslint ignore specific property names.
 */
export class VoucherAdapter implements Adapter<Voucher> {
  adapt(item: any): Voucher {
    let voucher: Voucher;
    if (item) {
      voucher = new Voucher(
        item.voucherCode,
        item.isValid,
        item.expiration_date,
        item.code,
        item.code_name,
        item.message
      );
    }
    return voucher;
  }
}
